function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef } from 'react';
import { BottomSheetHeader, DropdownMenu, DropdownMenuItem, IconButton, Menu, useDevice, useOverlayContext } from 'seagull';
import { CircledQuestion24 } from 'seagull/icons';
import { openInNewTabProps } from "../../../constants";
import { ExternalLink, useHelpMenuExternalLinks } from "../../../hooks/useHelpMenuExternalLinks";
import { Intent } from "../../../infra/access-control";
import { MobileTutorialVideos } from "./TutorialVideosModal/MobileTutorialVideos";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const menuLocation = 'header';
const HelpMenuButton = /*#__PURE__*/forwardRef(function HelpMenuButton(_ref, ref) {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(IconButton, {
    ref: ref,
    noPadding: true,
    intent: Intent.OpenHelpMenu,
    size: "small",
    onClick: onClick,
    "data-testid": "home-sidebar-help-menu-btn",
    children: /*#__PURE__*/_jsx(CircledQuestion24, {})
  });
});
function MobileHelpMenu() {
  const {
    showBottomSheet,
    pushBottomSheetPage
  } = useOverlayContext();
  const {
    externalLinks
  } = useHelpMenuExternalLinks({
    menuLocation,
    onOpenTutorialVideosInMobile: () => pushBottomSheetPage({
      content: /*#__PURE__*/_jsx(MobileTutorialVideos, {}),
      maxHeight: true,
      paddingBottom: 0
    })
  });
  return /*#__PURE__*/_jsx(HelpMenuButton, {
    onClick: () => showBottomSheet({
      content: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BottomSheetHeader, {
          title: "Help & support"
        }), /*#__PURE__*/_jsx(Menu, {
          dimensions: {
            width: 'auto',
            paddingTop: 16
          },
          items: externalLinks.map(link => _objectSpread({
            id: link.label,
            body: link.label,
            testId: "home-sidebar-menuitem-".concat(link.label),
            prefixIcon: link.icon ? /*#__PURE__*/_jsx(link.icon, {}) : null,
            suffixIcon: link.suffixIcon
          }, link.type === ExternalLink.Link ? {
            externalLink: {
              href: link.href,
              openInNewTab: true
            }
          } : {
            onClick: link.onClick
          }))
        })]
      })
    })
  });
}
function DesktopHelpMenu() {
  const {
    externalLinks
  } = useHelpMenuExternalLinks({
    menuLocation
  });
  return /*#__PURE__*/_jsx(DropdownMenu, {
    minWidth: 175,
    target: /*#__PURE__*/_jsx(HelpMenuButton, {}),
    children: externalLinks.map(link => /*#__PURE__*/_jsx(DropdownMenuItem, _objectSpread(_objectSpread({
      "data-testid": "home-sidebar-menuitem-".concat(link.label),
      iconStart: link.icon ? /*#__PURE__*/_jsx(link.icon, {}) : null
    }, link.type === ExternalLink.Link ? _objectSpread({
      as: 'a',
      href: link.href
    }, openInNewTabProps) : {
      onClick: link.onClick
    }), {}, {
      children: link.label
    }), link.label))
  });
}
export function HelpMenu() {
  const {
    isMobileDevice
  } = useDevice();
  return isMobileDevice ? /*#__PURE__*/_jsx(MobileHelpMenu, {}) : /*#__PURE__*/_jsx(DesktopHelpMenu, {});
}